export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const LOADING_INC = 'LOADING_INC'
export const LOADING_DEC = 'LOADING_DEC'